import { render, staticRenderFns } from "./ButtonSubmit.vue?vue&type=template&id=6b40d279&"
import script from "./ButtonSubmit.vue?vue&type=script&lang=js&"
export * from "./ButtonSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports